export const CREATE_NEW_USER_CHECKIN_PROFILE =
  '[user] create new user checkin profile';
export const PROCESS_NEW_USER_CHECKIN_PROFILE =
  '[user] process new user checkin profile';
export const PROCESS_USER_CHECKIN_PROFILE =
  '[user] process user checkin profile';
export const LOAD_USER_CHECKIN_PROFILE = '[user] load user checkin profile';
export const INSERT_USER_CHECKIN_PROFILE = '[user] insert user checkin profile';
export const EDIT_USER_CHECKIN_PROFILE = '[user] edit user checkin profile';
export const USER_CHECKIN_PROFILE_ERROR = '[user] user checkin profile error';
export const USER_CHECKIN_PROFILE_CREATE_ERROR =
  '[user] user checkin profile create error';

export const editUserCheckinProfile = (
  profile,
  navigate,
  previous,
  formSteps
) => ({
  type: EDIT_USER_CHECKIN_PROFILE,
  payload: profile,
  navigate: navigate,
  previous,
  formSteps,
});
export const createNewUserCheckinProfile = (
  profile,
  navigate,
  previous,
  formSteps
) => ({
  type: CREATE_NEW_USER_CHECKIN_PROFILE,
  payload: profile,
  navigate: navigate,
  previous,
  formSteps,
});
export const processUserCheckinProfile = () => ({
  type: PROCESS_USER_CHECKIN_PROFILE,
});
export const processNewUserCheckinProfile = () => ({
  type: PROCESS_NEW_USER_CHECKIN_PROFILE,
});
export const loadUserCheckinProfile = (id) => ({
  type: LOAD_USER_CHECKIN_PROFILE,
  payload: id,
});
export const insertUserCheckinProfile = (profile) => ({
  type: INSERT_USER_CHECKIN_PROFILE,
  payload: profile,
});

export const userCheckinProfileError = (error) => ({
  type: USER_CHECKIN_PROFILE_ERROR,
  payload: error,
});
export const userCheckinProfileCreateError = (error) => ({
  type: USER_CHECKIN_PROFILE_CREATE_ERROR,
  payload: error,
});
